import styled from 'styled-components';

export const StyledPaper = styled.div`
  background-color: #fff;
  border-radius: 6px !important;
  margin-top: 22px;
`;
